import { actionTypes } from '../actions/menor.action';
const initialState = {
    cotas: []
}

const MenorReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.CHANGE:
        return {
            ...state,
            cotas: (payload === 'clear') ? [] : {
                ...state.cotas,
                ...payload
            }
        }

    default:
        return state
    }
}

export default MenorReducer